import { Component, Inject } from '@angular/core';
import { DIALOG_DATA, DialogService, DialogConfig, DialogRef } from '../dialog';
import { PdfService } from 'src/app/services/pdf.service';

@Component({
  selector: 'app-validation-retry-dialog',
  templateUrl: './validation-retry-dialog.component.html',
  styleUrls: ['./validation-retry-dialog.component.scss'],
})
export class ValidationRetryDialogComponent {
  loading = false;

  public static open(
    dialog: DialogService,
    data: ValidationRetryDialogData,
    config?: DialogConfig
  ): DialogRef<ValidationRetryDialogComponent, ValidationRetryDialogResult> {
    const c: DialogConfig = config || {};
    c.panelClass = 'simple-dialog';
    c.maxWidth = 'calc(100vw - 32px)';
    c.data = data;
    return dialog.open(ValidationRetryDialogComponent, c);
  }

  constructor(
    public dialogRef: DialogRef<ValidationRetryDialogComponent>,
    @Inject(DIALOG_DATA) public data: ValidationRetryDialogData,
    private pdfService: PdfService
  ) {}

  onOkClick() {
    this.loading = true;
    this.pdfService
      .downloadAndValidate(this.data.url, this.data.secret)
      .subscribe({
        next: (result) => {
          this.dialogRef.close({
            url: result.url,
            status: result.status,
          });
        },
        error: () => {
          this.loading = false;
        },
      });
  }

  onNoClicked() {
    this.dialogRef.close(null);
  }
}

export interface ValidationRetryDialogData {
  title: string;
  titleStyle?: { [key: string]: string | number };
  content?: string;
  contentStyle?: { [key: string]: string | number };
  noButton?: string;
  yesButton?: string;
  color?: 'primary' | 'accent';
  url: string;
  secret: string;
}

export interface ValidationRetryDialogResult {
  url: string;
  status: string;
}
